import { render, staticRenderFns } from "./OrderViewServices.vue?vue&type=template&id=2a4e0e25&scoped=true&"
import script from "./OrderViewServices.vue?vue&type=script&lang=js&"
export * from "./OrderViewServices.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewServices.vue?vue&type=style&index=0&id=2a4e0e25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e0e25",
  null
  
)

export default component.exports